import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artists: hasMany('artist', { inverse: null }),
  channelsAdditive: hasMany('channel', { inverse: null }),
  channelsExcluded: hasMany('channel', { inverse: null }),
  channelsExclusive: hasMany('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  locationPartners: hasMany('live-partner', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  presenterPartners: hasMany('live-partner', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  type: belongsTo('category', { inverse: null }),
});
